import {formatMoney} from './utils.js';

function initializeQuantityBundles() {
  const quantityBundleButtons = document.querySelectorAll('.js-quantity-bundle-button');

  if (!quantityBundleButtons.length) return;

  quantityBundleButtons.forEach((radio) => {
    radio.addEventListener('change', updatePrices);
  });

  // Listen for the custom event globally
  document.addEventListener('quantityBundleReset', (event) => {
    const price = event.detail.price;
    const firstRadio = document.querySelector('.js-quantity-bundle-button:checked');
    if (firstRadio) {
      updatePrices.call(firstRadio, event, price);
    }
  });

  if (quantityBundleButtons.length > 0) {
    quantityBundleButtons[0].checked = true;
    quantityBundleButtons[0].dispatchEvent(new Event('change'));
  }

  subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
    const checkedRadio = document.querySelector('.js-quantity-bundle-button:checked');
    if (!checkedRadio) return;

    checkedRadio.dispatchEvent(new Event('change'));

    if (!quantityBundleButtons[0]) return;
    quantityBundleButtons[0].checked = true;
    quantityBundleButtons[0].dispatchEvent(new Event('change'));
  });
}

function currencyFormatter(value, country, language, currency) {
  const formattedValue = value / 100;

  return new Intl.NumberFormat(`${language}-${country}`, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(formattedValue);
}

// Quantity Per Pack selectors
function getQuantityPerPack(quantity) {
  const sizeLabel = document.querySelector('input[type="radio"].option-size-radio:checked');
  const countLabel = document.querySelector('.variant-qty-count');
  let quantityPerPack;

  if (sizeLabel) {
    quantityPerPack = parseInt(sizeLabel.dataset.quantityPerPack);
  } else if (countLabel) {
    const extractNumber = (str) => parseInt(str.match(/\d+/)?.[0] || null);
    quantityPerPack = extractNumber(countLabel.textContent);
  }

  if (quantityPerPack && document.querySelector('.product-quantity')) {
    document.querySelector('.product-quantity').textContent = (
      quantityPerPack * quantity
    ).toString();
  }

  return quantityPerPack;
}

function updatePrices(event, overridePrice) {
  const priceElement = document.querySelector('.js-price-unit');
  const quantityInput = document.querySelector('.quantity__input');
  const subtotalElement = document.querySelector('.js-price-subtotal');
  const mainPriceElement = document.querySelector('.price-item.price-item--regular.js-price-unit');
  const pricePerPiece = document.querySelector('.js-price-per-piece');

  const {country, language, currency} = window.ShopifyLocalization;

  const quantity = parseInt(this.dataset.quantity);
  const discount = parseInt(this.dataset.discount) || 0;

  quantityInput.value = quantity;

  const singlePackPrice = Number(overridePrice || priceElement.dataset?.priceNumber);
  const bundlePrice = singlePackPrice * quantity;
  const discountedSinglePackPrice = Math.ceil(singlePackPrice * (1 - discount / 100));
  const discountedBundlePrice = discountedSinglePackPrice * quantity;

  const isPurchaseOptionsSubtotal = subtotalElement && subtotalElement.closest('.purchase-options');
  const subtotalPrice = isPurchaseOptionsSubtotal ? singlePackPrice : bundlePrice;
  const subtotalDiscountedPrice = isPurchaseOptionsSubtotal ? discountedSinglePackPrice : discountedBundlePrice;

  if (discount > 0 && subtotalElement) {
    const formattedPrice =
      window.Shopify.country === 'NL'
        ? formatMoney(subtotalPrice, '€ {{amount_with_comma_separator}}')
        : currencyFormatter(subtotalPrice, country, language, currency);
    const formattedDiscountedPrice =
      window.Shopify.country === 'NL'
        ? formatMoney(subtotalDiscountedPrice, '€ {{amount_with_comma_separator}}')
        : currencyFormatter(subtotalDiscountedPrice, country, language, currency);
    subtotalElement.innerHTML = `<span class="strikethrough">${formattedPrice}</span>&nbsp;${formattedDiscountedPrice}`;
  } else if (subtotalElement) {
    const formattedPrice =
      window.Shopify.country === 'NL'
        ? formatMoney(subtotalPrice, '€ {{amount_with_comma_separator}}')
        : currencyFormatter(subtotalPrice, country, language, currency);
    subtotalElement.innerHTML = formattedPrice;
  }
  if (mainPriceElement) {
    const mainPrice = isPurchaseOptionsSubtotal ? singlePackPrice : discountedBundlePrice;
    mainPriceElement.innerHTML = currencyFormatter(mainPrice, country, language, currency);
  }

  const quantityPerPack = getQuantityPerPack(quantity);

  if (quantityPerPack) {
    const totalPieces = quantityPerPack * quantity;
    const pricePerPieceValue = isPurchaseOptionsSubtotal
      ? singlePackPrice / quantityPerPack
      : discountedBundlePrice / totalPieces;
    if (pricePerPiece) {
      pricePerPiece.innerHTML = `${currencyFormatter(pricePerPieceValue, country, language, currency)}`;
    }
  }
  
  const purchaseOptions = document.querySelector('.js-purchase-options');
  if (purchaseOptions) {
    initializePurchaseOptionPrices(singlePackPrice, country, language, currency);
    updateQuantityPerPack(quantity);
  }
}

function initializePurchaseOptionPrices(priceNumber, country, language, currency) {
  const quantityBundleButtons = document.querySelectorAll('.js-quantity-bundle-button');
  if (!quantityBundleButtons.length) return;

  quantityBundleButtons.forEach((radio, index) => {
    const quantity = parseInt(radio.dataset.quantity);
    const discount = parseInt(radio.dataset.discount) || 0;
    const originalTotalPrice = priceNumber * quantity;
    const discountAmount = Math.floor(priceNumber * (discount / 100));
    const bundlePrice = priceNumber - discountAmount;
    const discountedPrice = bundlePrice * quantity;

    // Find the price display elements for this bundle
    const originalPriceEl = document.querySelector(`.js-bundle-price-original-${index + 1}`);
    const discountedPriceEl = document.querySelector(`.js-bundle-price-discounted-${index + 1}`);

    if (originalPriceEl && discountedPriceEl) {
      if (discount > 0) {
        // Show both original (strikethrough) and discounted price
        originalPriceEl.innerHTML = `<span class="strikethrough">${currencyFormatter(originalTotalPrice, country, language, currency)}</span>`;
        discountedPriceEl.innerHTML = currencyFormatter(discountedPrice, country, language, currency);
      } else {
        // Only show regular price (total for quantity)
        originalPriceEl.innerHTML = '';
        discountedPriceEl.innerHTML = currencyFormatter(
          bundlePrice * quantity,
          country,
          language,
          currency
        );
      }
    }
  });
}

function updateQuantityPerPack(quantity) {
  const packageQuantity = document.querySelector('.js-pack');
  const multiplePackage = document.querySelector('.js-multiple-package');
  const singlePackage = document.querySelector('.js-single-package');
  const productQuantity = document.querySelector('.js-product-quantity');
  const quantityPerPack = getQuantityPerPack(quantity);

  if (multiplePackage && singlePackage) {
    if (quantity > 1) {
      multiplePackage.classList.remove('hidden');
      singlePackage.classList.add('hidden');
    } else {
      multiplePackage.classList.add('hidden');
      singlePackage.classList.remove('hidden');
    }
  }

  if (packageQuantity) {
    packageQuantity.innerHTML = quantity;
  }
  if (productQuantity && quantityPerPack) {
    productQuantity.innerHTML = quantity * quantityPerPack;
  }
}

document.addEventListener('DOMContentLoaded', initializeQuantityBundles);
